export const isRetiredWithoutFmh = (practice) =>
  Boolean(practice) &&
  practice.is_patient_fusion_retired === true &&
  practice.is_fmh_onboarding_completed !== true;
